/**
 * `analytics` will provide an instance of the AnalyticsService that will
 * allow for tracking events to be sent to Segment
 */
import { AnalyticsV2Service } from './AnalyticsV2Service.generated';

export const analytics = new AnalyticsV2Service();

export * from './sendAnalyticsIdentify';
